import './index.scss';

import { Component } from 'react';
import { BraxButton, BraxCheckboxField, BraxIcon, BraxTextField } from 'design-system';

import { PaymentInterval } from '../../../../variables/payment-interval';
import { PaymentMethod } from '../../../../variables/payment-method';
import { PaymentInstallments } from '../../../../variables/payment-installments';
import planPrices from '../../../../variables/plan-prices';
import t from '../../../../utils/i18n';
import formatters from '../../../../utils/formatters';
import handleError, { ErrorInfo } from '../../../../utils/errors';
import payment from '../../../../utils/payment';
import User from '../../../../view-model/users/User';
import Plan from '../../../../view-model/plans/Plan';
import Coupon from '../../../../view-model/payment/Coupon';
import paymentsService from '../../../../services/payments';

export type CheckoutStepThreeFieldsProps = {
    user: User,
    subscribing: boolean,
    interval: PaymentInterval,
    method: PaymentMethod,
    installments: PaymentInstallments,
    plan: Plan,
    cardNumber?: string,
    coupon?: string,
    disabled: boolean,
    // onSelectCoupon: (coupon: string) => void
};

type CheckoutStepThreeFieldsState = {
    coupon: Coupon | null | false,
    error: ErrorInfo | null
};

export default class CheckoutStepThreeFields extends Component<CheckoutStepThreeFieldsProps, CheckoutStepThreeFieldsState> {

    state: CheckoutStepThreeFieldsState = {
        coupon: null,
        error: null
    };

    prices = { ...planPrices };

    componentDidMount() {
        if (this.props.coupon)
            this.validateCoupon();
    }

    componentDidUpdate(prevProps: CheckoutStepThreeFieldsProps) {
        if (prevProps.plan.id !== this.props.plan.id || prevProps.interval !== this.props.interval || prevProps.method !== this.props.method || prevProps.installments !== this.props.installments)
            this.validateCoupon();
    }

    async validateCoupon(coupon = this.props.coupon) {
        this.setState({ error: null, coupon: null });

        if (!coupon)
            return;

        try {
            this.setState({
                coupon: (await paymentsService.validateCoupon({
                    user: this.props.user.id,
                    coupon: coupon,
                    plan: this.props.plan.id,
                    interval: this.props.interval,
                    method: this.props.method,
                    installments: this.props.installments
                })).result
            });
        } catch (error) {
            this.setState({
                coupon: false,
                error: handleError(error, 'Não foi possível consultar o cupom')
            });
        }
    }

    // onSelectCoupon(coupon: string) {
    //     this.props.onSelectCoupon(coupon);

    //     this.validateCoupon(coupon);
    // }

    render() {
        const installments = this.props.interval === 'monthly' ? 1 : this.props.installments;

        const planPrice = formatters.moneyToInt(this.prices[this.props.plan.id][this.props.interval]);

        const planInstallmentPrice = planPrice / installments;

        const totalPrice = this.state.coupon ? this.state.coupon.total : planPrice;

        const totalInstallmentPrice = totalPrice / installments;

        return (
            <div className={`checkout-step-three-field ${this.props.disabled ? 'step-disabled' : ''}`}>
                <h3>3. { t('Confirmação') }</h3>

                <BraxTextField
                    type="text"
                    name="plan.title"
                    label={t('Plano selecionado')}
                    disabled={this.props.disabled}
                    readOnly={!this.props.disabled}
                />

                <p className="payment-method">
                    <span className="label">{ t('Condição de pagamento') }</span>

                    <span>
                        <BraxIcon icon="card" />

                        <span>
                            { t(this.props.interval === 'monthly'
                                ? 'Pagamento mensal'
                            : this.props.installments > 1
                                ? 'Pagamento parcelado'
                                : 'Pagamento à vista'
                            ) }
                            { ' - ' }
                            { t(this.props.method === 'credit_card' ? 'Cartão de Crédito' : 'Boleto ou Pix') }
                        </span>

                        { this.props.method === 'credit_card' && this.props.cardNumber ? (<>
                            <br />

                            <span>
                                { payment.Iugu.utils.getBrandByCreditCardNumber(this.props.cardNumber) }
                                { ' ' }
                                **** **** **** { this.props.cardNumber.split(' ')[3] }
                            </span>
                        </>) : null }
                    </span>
                </p>

                <div className="coupon">
                    <BraxTextField
                        type="text"
                        name="couponCode"
                        label={t('Cupom de desconto')}
                        placeholder={t('Digite aqui o cupom')}
                        status={this.props.disabled ? 'disabled' : this.state.error ? 'error' : this.state.coupon ? 'success' : undefined}
                        hint={this.state.error ? this.state.error.description : this.state.coupon ? t('Cupom válido') : undefined}
                    />

                    <BraxButton variant="secondary" disabled={this.props.disabled} onClick={() => this.validateCoupon()}>
                        { t('Validar') }
                    </BraxButton>
                </div>

                {/* { this.props.user.plan.isFree ? (
                    <CheckoutCoupons
                        disabled={this.props.disabled}
                        open={!this.props.coupon}
                        onSelect={coupon => this.onSelectCoupon(coupon)}
                    />
                ) : null } */}

                { this.props.interval === 'yearly' ? (
                    <p className={`payment-installments ${this.state.coupon ? 'has-discount' : ''}`}>
                        <span className="label">{ t('Número de parcelas') }</span>

                        <span className={this.state.coupon ? 'price-slashed' : undefined}>
                            <span>{ installments }x R$ </span>

                            <span>{ formatters.numberToMoney(planInstallmentPrice / 100, false) }</span>
                        </span>

                        { this.state.coupon ? (<>
                            <span>
                                { this.state.coupon.type === 'amount' ? (<>
                                    <span>- R$ </span>

                                    <span>{ formatters.numberToMoney(this.state.coupon.discount / 100, false) } </span>
                                </>) : (<>
                                    <span>- </span>

                                    <span>{ this.state.coupon.percentage }% </span>
                                </>) }

                                <span>({ t('cupom de desconto') })</span>
                            </span>

                            <span>
                                <span>{ installments }x R$ </span>

                                <span>{ formatters.numberToMoney(totalInstallmentPrice / 100, false) }</span>
                            </span>
                        </>) : null }
                    </p>
                ) : null }

                <p className="payment-total">
                    <span className="label">{ t('Total a pagar') }</span>

                    <span>
                        <span>R$ </span>

                        <span>{ formatters.numberToMoney(totalPrice / 100, false) }</span>
                    </span>
                </p>

                <div>
                    <BraxCheckboxField
                        name="terms"
                        label={t('Li e aceito os <link>termos de uso</link> e <link>política de privacidade</link>.')}
                        disabled={this.props.disabled}
                    />

                    <BraxCheckboxField
                        name="renovation"
                        label={t('Estou ciente que as renovações da assinatura ocorrem sempre de forma automática.')}
                        disabled={this.props.disabled}
                    />
                </div>

                <BraxButton type="submit" disabled={this.state.coupon === false || this.props.subscribing || this.props.disabled}>
                    { t(this.props.subscribing ? 'Assinando...' : 'Assinar') }
                </BraxButton>
            </div>
        );
    }

}
